import type { ReactNode } from 'react';

export function Badge({ children }: { children: ReactNode }) {
  return (
    <span className="responsive flex flex-wrap justify-end gap-1 whitespace-nowrap rounded-xs bg-primary px-3 py-1 text-white">
      {children}
    </span>
  );
}
